import type { ParsedUrlQuery } from 'querystring';

function queryToSearchParams(query: ParsedUrlQuery): URLSearchParams {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(query)) {
    if (value === undefined) {
      continue;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => params.append(key, item));
    } else {
      params.set(key, value);
    }
  }

  return params;
}

/**
 * Appends current route query params to a target URL.
 * Params already present in the target URL are not overwritten.
 */
export function appendRouteQuery(url: string, query: ParsedUrlQuery): string {
  const routeParams = queryToSearchParams(query);

  if ([...routeParams.keys()].length === 0) {
    return url;
  }

  const [path, existingSearch = ''] = url.split('?');
  const urlParams = new URLSearchParams(existingSearch);

  routeParams.forEach((value, key) => {
    if (!urlParams.has(key)) {
      urlParams.set(key, value);
    }
  });

  const queryString = urlParams.toString();
  return queryString ? `${path}?${queryString}` : path;
}
